import { createLogoComponent } from './helpers/createLogoComponent';
import {
  mapComponentByName,
  PaymentSystemName,
} from './helpers/mapComponentByName';

export const PaymentSystemLogo = Object.keys(mapComponentByName).reduce(
  (result, name) => {
    return {
      ...result,
      [name]: createLogoComponent(name as PaymentSystemName),
    };
  },
  {} as { [key in PaymentSystemName]: ReturnType<typeof createLogoComponent> },
);
